const emergencyTypeHelper = {
    formatEmergencyType(type) {
        const typeMap = {
            0: "Unknown Emergency",
            1: "Vehicular Accident",
            2: "Domestic Violence",
            3: "Fire Incident",
            4: "Drowning Incident",
            5: "Medical Assistance",
            100: "Other Emergency Type",
        };
        return typeMap[type] || "Unknown Emergency";
    },

    getEmergencyIcon(type) {
        const iconMap = {
            0: "bi-question-circle",
            1: "bi-car-front",
            2: "bi-exclamation-triangle",
            3: "bi-fire",
            4: "bi-droplet",
            5: "bi-heart-pulse",
            100: "bi-heart-pulse",
        };
        return iconMap[type] || "bi-question-circle";
    },

    getEmergencyTypeClass(type) {
        const classMap = {
            0: "unknown",
            1: "accident",
            2: "violence",
            3: "fire",
            4: "drowning",
            5: "medical",
            100: "others",
        };
        return classMap[type] || "unknown";
    },
    getEmergencyClass(emergencyType) {
        const classes = {
            Medical: "medical",
            Fire: "fire",
            Police: "police",
            Rescue: "rescue",
            CoastGuard: "coastguard",
            LeyecoV: "leyeco",
        };
        return classes[emergencyType] || "default";
    }
}



export default emergencyTypeHelper;